/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteActivityItem} from '../api'

export const useMutationDeleteActivityItem = createReactQueryMutationHook('deleteActivityItem', deleteActivityItem)
